const ViewEditHelper = {
  onSaveChangesClick(context, removeEmailsList, addEmailsList, bpNumber) {
      context.state.doneEnable = false;
      app.settingsService.getPaperlessBillingUpdateDetails(bpNumber, removeEmailsList, addEmailsList ).then(
          (response) => {
              context.state.doneEnable = true;
              if (!response.errorCode) {
                  context.setState({  isGlobalError: false, popUpMsg: context.strings.UpdateSuccessMsg, msgIcon: true, isViewEditPopup:false });
              } else {
                  context.setState({ isGlobalError: true, popUpMsg: context.strings.UpdateFailureMsg, msgIcon: false, isViewEditPopup:false });
                  app.logger.getLogger().info("Paperless Billing Modify details: Handle service error");
                  app.logger.getLogger().info(error);
              }
          },
          (error) => {
              //setTimeout(() => window.location.reload(), 60000);
              context.setState({ isGlobalError: true, popUpMsg: context.strings.UpdateFailureMsg, msgIcon: false, isViewEditPopup:false });
              app.logger.getLogger().info("Paperless Billing Modify details: Handle service error");
              app.logger.getLogger().info(error);
          });
  },
  onUpdateEmail(email, contractAccountNumber, soldEmails, lastEnorlledEmail) {
      let soldEmailList = [];
      let removeEmailsList = [];
      let emailFound = false;
      let pstDate = app.appUtil.DateUtil.getPSTDate(new Date());
       let validToDate = app.appUtil.DateUtil.getEDMDate(pstDate);
      let newEmailObj = {
          solution: 'U', objectType: 'ISUACCOUNT', objectKey: '', contractAccountNumber: contractAccountNumber, category: 'PAPR', messageType: 'EBILL',
          buPartner: app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber, channel: 'INT', recordGUID: 'NEW', email: email, type:'soldTo',
          validFromDate: validToDate, validFromTime: '', validToDate: validToDate, validToTime: '',  
          removeFromDate: null,
      }; 
      for(let obj of soldEmails){
        if(obj.email === lastEnorlledEmail){
          emailFound = true;
          removeEmailsList.push(obj);
          soldEmailList.push(newEmailObj);
        }else{
          soldEmailList.push(obj);
        }
      }
      if(!emailFound){
          soldEmailList.push(newEmailObj);
      }
      return {soldEmailList, removeEmailsList};
  },

  submitDeenrollClick () {
      window.aUtils.sendAAEvent("button","paperlessBillingTurnOff");
      let ebillpaprRecord = this.state.removeEmailsList;
      app.logger.getLogger().info("Paperless Billing DeEnroll: Submit");
      app.settingsService.getPaperlessBillingDeEnrollDetails(this.props.accountData.bpNumber, ebillpaprRecord, app.appService.getUserInfo().profileData, this.props.accountData.contractAccountNumber).then(
        (res) => {
          window.scrollTo(0, 0);
          this.setState({deEnrollConfirmPopup: true, yesCancelDeEnroll: true});
        },
        (error) => {  
          this.setState({isPbDeEnrollConfirm: false});
        }
      );
    },
};

export default ViewEditHelper;
